import { ChannelSummary } from 'ChannelSummary'
import type { DetailsType } from 'ChannelSummary/constants'
import { CommonAlert } from 'CommonAlert'
import { selectCountriesList } from 'data/selectors'
import { GroupDetails } from 'GroupDetails'
import { LoadingOverlay } from 'LoadingOverlay'
import { selectLanguage } from 'locale/selectors'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'

import Box from '@mui/material/Box'

import useStyles from './useStyles'

interface Props {
  channel?: string
  countryId?: string
  detailsType?: DetailsType
  owner?: string
  saleType?: string
}

function CountriesList({ countryId, channel, detailsType, owner, saleType }: Props) {
  const { errorCode, isLoading, list } = useSelector(selectCountriesList({ channel, countryId, owner, saleType }))
  const language = useSelector(selectLanguage).toUpperCase()
  const classes = useStyles()
  const showSkeletonLoader = list.length === 0 && isLoading

  return (
    <LoadingOverlay isLoading={showSkeletonLoader}>
      <Box minHeight={showSkeletonLoader ? '6rem' : '0'}>
        {Boolean(errorCode) && <CommonAlert errorCode={errorCode} />}
        {list.map(data => {
          const { countryId } = data

          return (
            <ChannelSummary
              key={`${owner || saleType || channel}.${countryId}`}
              channel={channel}
              className={classes.root}
              countryId={countryId}
              data={data}
              detailsType={detailsType}
              isLoading={isLoading}
              label={data[`countryName${language}`] || ''}
              owner={owner}
              saleType={saleType}
              type="countries"
            >
              <GroupDetails
                channel={channel}
                countryId={countryId}
                owner={owner}
                data={data}
                isLoading={isLoading}
                saleType={saleType}
                type="countries"
              />
            </ChannelSummary>
          )
        })}
      </Box>
    </LoadingOverlay>
  )
}

export default memo<Props>(CountriesList)
